export default {
  methods: {
    fomatNumber(number) {
      return Math.round(number).toLocaleString();
    },
    formatMoney(amount) {
      return parseFloat(amount).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    formatDuration(seconds) {
      if (!seconds || seconds === 0) return "00:00:00";

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    },
    truncateString(string, maxLength = 30) {
      return string.length > maxLength
        ? string.substring(0, maxLength) + "..."
        : string;
    },
  },
};
